import { render, staticRenderFns } from "./turnover.vue?vue&type=template&id=cf75abd8&scoped=true&"
import script from "./turnover.vue?vue&type=script&lang=js&"
export * from "./turnover.vue?vue&type=script&lang=js&"
import style0 from "./turnover.vue?vue&type=style&index=0&id=cf75abd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf75abd8",
  null
  
)

export default component.exports